import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setDefaultShippingAddress } from '../../api/apiStorefront';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useSetDefaultShippingAddress = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (addressId) => {
      if (!addressId) {
        throw new Error('Address ID is required');
      }
      const response = await setDefaultShippingAddress(addressId);
      return response.data;
    },
    onSuccess: (data) => {
      toast.success(t('address.defaultShippingSet', 'Default shipping address set successfully!'));
      // Invalidate multiple queries to ensure fresh data
      queryClient.invalidateQueries({ queryKey: ['customer-addresses'] });
      queryClient.invalidateQueries({ queryKey: ['customer'] });
    },
    onError: (error) => {
      console.error('Error setting default shipping address:', error);
      const message = error.response?.data?.message || error.message || t('address.defaultShippingError', 'Failed to set default shipping address');
      toast.error(message);
    },
  });
};

